import { useCallback } from 'react'
import { stakeFarm } from 'utils/calls'
import { useMasterchef } from 'hooks/useContract'
import { useFeeDataWithGasPrice } from 'state/user/hooks'

const useStakeFarms = (pid: number) => {
  const masterChefContract = useMasterchef()
  const { maxFeePerGas, maxPriorityFeePerGas } = useFeeDataWithGasPrice()

  const handleStake = useCallback(
    async (amount: string) => {
      return stakeFarm(masterChefContract, pid, amount, maxFeePerGas, maxPriorityFeePerGas)
    },
    [masterChefContract, pid, maxFeePerGas, maxPriorityFeePerGas],
  )

  return { onStake: handleStake }
}

export default useStakeFarms
